<template>
  <ModalContainer :show="show" @close="onCancel">
    <loading
      :active.sync="isLoading"
      :is-full-page="fullPage"
      loader="bars"
    ></loading>

    <template slot="header">
      <h4 class="mb-0">{{ $t("add-destination") }}</h4>
    </template>

    <template slot="body">
      <form class="p-2" @submit.prevent="addorigin">
        <div style="display: flex; justify-content: space-between; gap: 1rem;">
          <div style="width: 100%;">
            <div class="form-group">
              <label for="company"> {{ $t("company") }}</label>
              <input
                type="text"
                name="company"
                v-model="company"
                class="form-control"
                required
                id="company"
                :placeholder="$t('enter-company')"
                style="text-transform: capitalize;"
                @keypress="isLetter($event)"
              />
            </div>

            <div class="form-group">
              <label for="personOfContact">
                {{ $t("person-of-contact") }}</label
              >
              <input
                v-model="personOfContact"
                type="text"
                name="personOfContact"
                class="form-control"
                required
                id="personOfContact"
                :placeholder="$t('enter-person-of-contact')"
              />
            </div>
          </div>

          <div style="width: 100%;">
            <div class="form-group">
              <label for="region"> {{ $t("region") }}</label>
              <input
                v-model="region"
                type="text"
                name="region"
                class="form-control"
                required
                id="region"
                :placeholder="$t('enter-region')"
              />
            </div>

            <div class="form-group">
              <label for="country"> {{ $t("country") }} </label>
              <CountrySelect
                class="form-control"
                required
                id="country"
                v-model="country"
                :country="country"
                :countryLabel="'Select a Country'"
                :defaultOption="'Select a country'"
                :countryName="true"
              />
            </div>
          </div>
        </div>
        <div style="width: 100%">
          <div class="form-group">
            <label for="address"> {{ $t("address") }}</label>
            <input
              type="text"
              name="address"
              class="form-control"
              required
              id="autocomplete"
              :placeholder="$t('enter-address')"
              ref="autocompleteInput"
            />
          </div>
        </div>
        <div type="submit" class="btn-add">
          <button>{{ $t("add") }}</button>
        </div>
      </form>
    </template>
  </ModalContainer>
</template>

<script>
import ModalContainer from "../../components/ModalContainer";
import { mapGetters, mapActions } from "vuex";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { CountrySelect } from "vue-country-region-select";

export default {
  name: "AddDestination",
  components: {
    ModalContainer,
    Loading,
    CountrySelect,
  },
  props: {
    show: Boolean,
    onCancel: Function,
    isAddShipment: {
      type: Boolean,
      default: false,
    },
    newShipmentDestination: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      isLoading: false,
      fullPage: true,

      company: "",
      region: "",
      personOfContact: "",
      mssg: "",
      Errormssg: "",
      country: "",

      lat: null,
      lng: null,
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.initializeAutocomplete();
    });
  },
  computed: {
    ...mapGetters([]),
  },
  methods: {
    ...mapActions(["addDestination", "getDestinations"]),
    isLetter(e) {
      let char = String.fromCharCode(e.keyCode);
      if (/^[a-zA-Z\s\b]*$/.test(char)) return true;
      else e.preventDefault();
    },
    initializeAutocomplete() {
      const { google } = window;
      this.geocoder = new google.maps.Geocoder();
      const input = document.getElementById("autocomplete");
      const autocomplete = new google.maps.places.Autocomplete(input);

      autocomplete.addListener("place_changed", () => {
        const place = autocomplete.getPlace();

        if (place && place.formatted_address) {
          this.address = place.formatted_address;

          const latLng = place.geometry?.location;

          if (latLng) {
            this.lat = latLng.lat();
            this.lng = latLng.lng();
            console.log("Latitude:", this.lat);
            console.log("Longitude:", this.lng);
          }
        } else {
          const inputAddress = document.getElementById("autocomplete").value;
          console.log(
            "Address not found in autocomplete, geocoding:",
            inputAddress
          );

          this.geocoder.geocode(
            { address: inputAddress },
            (results, status) => {
              if (
                status === google.maps.GeocoderStatus.OK &&
                results.length > 0
              ) {
                const result = results[0];
                const latLng = result.geometry.location;
                this.lat = latLng.lat();
                this.lng = latLng.lng();

                console.log("Geocoded Latitude:", this.lat);
                console.log("Geocoded Longitude:", this.lng);
              } else {
                console.error("Geocoding failed:", status);
              }
            }
          );
        }
      });
    },

    addorigin() {
      this.isLoading = true;
      const newDestination = {
        name: this.company,
        address: {
          name: document.getElementById("autocomplete").value,
          lat: this.lat,
          lng: this.lng,
        },
        region: this.region,
        country: this.country,
        personOfContact: this.personOfContact,
      };
      if (this.isAddShipment)
        return this.$emit("newDestination", newDestination);
      this.addDestination(newDestination)
        .then((res) => {
          this.getDestinations();
          this.isLoading = false;
          this.onCancel();
          this.$emit("showSuccessPopup", {
            msg: this.$t("add_destination_mssg"),
            heading: this.$t("add_destination_heading"),
          });
        })
        .catch((error) => {
          console.error("Error adding origin:", error);
          this.isLoading = false;
          this.Errormssg = "Error adding origin. Please try again.";
        });
    },
  },
  watch: {
    newShipmentDestination: {
      handler(newValues) {
        if (newValues.address && this.isAddShipment) {
          this.$nextTick(() => {
            const autocompleteInput = this.$refs.autocompleteInput;
            if (autocompleteInput) {
              autocompleteInput.value = newValues.address.name;
              this.company = newValues.name;
              this.region = newValues.region;
              this.country = newValues.country;
              this.personOfContact = newValues.personOfContact;
            }
          });
        }
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style scoped>
label,
.form-control::placeholder {
  font-weight: 400;
  color: rgba(94, 106, 121, 1);
}

label {
  list-style: 15.6px;
  font-size: 12px;
}

.form-control::placeholder {
  font-size: 14px;
  line-height: 19.69px;
}

.btn-add {
  padding: 0;
  border-radius: 0;
  width: 100%;
  display: flex;
  justify-content: right;
}

.btn-add > button {
  border: none;
  border-radius: 16px;
  background-color: rgba(33, 62, 122, 1);
  color: rgba(247, 248, 249, 1);
  width: 84px;
  height: 44px;
  padding: 12px, 30px, 12px, 30px;
  font-size: 14px;
  font-weight: 600;
}
</style>
